import { useState, useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import {
  Page,
  Msg,
  LoadMore,
  Toast,
  Panel,
  PanelBody,
  MediaBox
} from 'react-weui';
import PropTypes from 'prop-types';
import { formatDate, formatNumber } from 'lib/formatter.ts';
import TopNav from 'components/topNav.js';
import * as MobileActions from 'actions/index.ts';
import useList from 'hooks/useList';
import CommonFns from 'functions/common.ts';

function InquiryBidFreightageList(props) {
  const Config = {
    purchase: {
      apiPath: '/logistics/bidding/getPageList',
      enumMainKey: '',
      companyNameKey: 'innerVendorName',
      detailLink: '/mp/purchase/inquiry/bid/freightage/detail',
      searchBarPlaceholder: '竞价编号/标题',
      tabs: ['全部', '待竞价', '竞价中', '比价中'],
      countApi: '/logistics/bidding/count',
      arrEnumField: [
        { mainKey: 'B02_Bid_Status', subKey: 'status', value: 'statusName' }
      ],
      countTransform: (data, self) => {
        //分类统计 [1待竞价, 3竞价中, 4比价中]
        let { 1: a, 2: b, 4: c } = data;
        setCount([undefined, a, b, c]);
      },
      tabConfig: [
        undefined, //全部
        [1], // 待竞价
        [2], //竞价中
        [4] //比价中
      ]
    },
    sale: {
      apiPath: '/logistics/cbidding/pageMultiProducts',
      enumMainKey: 'B02_Bid_Confirm_Flag',
      companyNameKey: 'innerCustomerName',
      detailLink: '/mp/sale/inquiry/bid/freightage/detail',
      searchBarPlaceholder: '竞价编号/标题',
      tabs: ['全部', '待竞价', '竞价中', '待发布结果'],
      countApi: '/logistics/cbidding/count',
      arrEnumField: [
        { mainKey: 'B02_Bid_Status', subKey: 'status', value: 'statusName' },
        {
          mainKey: 'B02_Bid_Confirm_Flag',
          subKey: 'confirmBiddingFlag',
          value: 'confirmBiddingFlagName'
        }
      ],
      countTransform: (data, self) => {
        //分类统计 [1待竞价, 3竞价中, 4待发布结果]
        let { 1: a, 2: b, 4: c } = data;
        setCount([undefined, a, b, c]);
      },
      tabConfig: [
        undefined, //全部
        [1], // 待竞价
        [2], //竞价中
        [4] //待发布结果
      ]
    }
  };
  const config = Config[props.type];
  const {
    companyCode,
    searchKey,
    inited,
    error,
    dataError,
    updateTs,
    currentTab,
    total,
    showLoading,
    list,
    count,
    setCount,
    handleTab,
    handleChange,
    handleClear,
    handleReset,
    self
  } = useList(props, config);

  //初始化默认企业
  useEffect(() => {
    self.init();
  }, [self]);

  //companyCode改变时执行
  useEffect(() => {
    self.getCount();
  }, [companyCode, self]);

  //根据依赖多次执行
  useEffect(() => {
    self.search();
  }, [searchKey, companyCode, currentTab, self]);

  self.beforeSearch = async function () {
    self.searchQueries = {
      status: config.tabConfig[currentTab],
      orderStatus: undefined
    };
  };

  // self.afterSearch() = async function(){
  //   self.list.forEach(item => {
  //   item.totalAmountShow = item.isContainTax === 1 ? item.totalTaxAmount : item.totalAmount;
  // });
  // };

  //显示错误
  if (error !== null) {
    return <Msg {...error} />;
  }

  return (
    <Page
      transition={false}
      ptr={false}
      onLoadMore={(resolveLoading, finish) => {
        self.pageResolveLoading = resolveLoading;
        if (list.length >= total) {
          finish();
        } else {
          self.search();
        }
      }}
      className="v2"
    >
      <TopNav
        inited={inited}
        onSubmit={handleChange}
        onCancel={handleClear}
        onClear={handleClear}
        defaultValue={searchKey}
        placeholder={config.searchBarPlaceholder}
      />
      <Panel>
        {dataError !== null ? (
          <Msg {...dataError} />
        ) : (
          <span>
            <div className="m-tab-container">
              <ul className="m-flex-box">
                {config.tabs.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => {
                      handleTab(index);
                    }}
                    className={
                      currentTab === index ? 'm-flex-item curr' : 'm-flex-item'
                    }
                  >
                    <span className="name">{item}</span>
                    {count[index] && (
                      <sup className="u-num">{count[index]}</sup>
                    )}
                  </li>
                ))}
              </ul>
            </div>
            <div className="list-total">{total}</div>
            <div className="m-details-item">
              <div className="details-item-content">
                {updateTs > 0 &&
                  list.map((item, index) => (
                    <Link
                      to={`${config.detailLink}/${companyCode}/${item.lboXkNo}`}
                      key={index}
                      className="content-line line-list-item"
                    >
                      <div className="line-list-item-title">
                        <span>{item.lboXkNo}</span>
                        <div className="more">
                          <span
                            className={
                              'u-sign ' +
                              CommonFns.getStatusClass(
                                'B02_Bid_Status',
                                item.status
                              )
                            }
                          >
                            {item.statusName}
                          </span>
                        </div>
                      </div>
                      <ul className="field-list">
                        <li>
                          <label>竞价项目标题</label>
                          <div className="blue">{item.billTitle}</div>
                        </li>
                        {self.isPurchase && (
                          <li>
                            <label>是否公开</label>
                            <div>
                              {item.biddingRangeType === 2 ? '公开' : '不公开'}
                            </div>
                          </li>
                        )}
                        <li>
                          <label>发布时间</label>
                          <div>{formatDate(item.publishTime)}</div>
                        </li>
                        <li>
                          <label>有效竞价时间</label>
                          <div>
                            {formatDate(item.lboStartDate, 'YYYY-MM-DD HH:mm')}{' '}
                            - {formatDate(item.lboEndDate, 'HH:mm')}
                          </div>
                        </li>

                        {!self.isPurchase ? (
                          <li>
                            <label>最终报价/报价次数</label>
                            <div>
                              {item.quotePrice ? item.quotePrice : '--'}
                              &nbsp;/&nbsp;{item.quoteCount}
                            </div>
                          </li>
                        ) : (
                          <li>
                            <label>收到邀约报价</label>
                            <div>
                              {item.qouteVendorCount}&nbsp;/&nbsp;
                              {item.vendorCount}
                            </div>
                          </li>
                        )}
                        {item.confirmBiddingFlagName && (
                          <li>
                            <label>竞价确认</label>
                            <div
                              className={
                                item.confirmBiddingFlag === 1
                                  ? 'green'
                                  : item.confirmBiddingFlag === 2
                                  ? 'red'
                                  : ''
                              }
                            >
                              {item.confirmBiddingFlagName}
                            </div>
                          </li>
                        )}
                        {!self.isPurchase && (
                          <li>
                            <label>竞价结果</label>
                            <div>
                              <span
                                className={
                                  'u-sign ' +
                                  (item.quoteSelectedFlag === 0
                                    ? 'orange'
                                    : 'green')
                                }
                              >
                                {item.quoteSelectedFlag === 1
                                  ? '入选'
                                  : item.quoteSelectedFlag === 0
                                  ? '未入选'
                                  : ''}
                              </span>
                            </div>
                          </li>
                        )}
                      </ul>
                    </Link>
                  ))}
                {!showLoading && list.length === 0 && (
                  <LoadMore showLine> 暂无数据</LoadMore>
                )}
              </div>
            </div>
          </span>
        )}
      </Panel>
      <Toast icon="loading" show={showLoading}>
        数据加载中...
      </Toast>
    </Page>
  );
}

InquiryBidFreightageList.propTypes = {
  actions: PropTypes.object.isRequired
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(MobileActions, dispatch)
  };
};

export default connect(mapDispatchToProps)(InquiryBidFreightageList);
